import React, { useEffect } from "react";
import { Chrono } from "react-chrono";
import { TimelineItemModel } from "react-chrono/dist/models/TimelineItemModel";
import InProgressIcon from "../../../../assets/images/icons/timeline-in-progress.png";
import OkIcon from "../../../../assets/images/icons/timeline-ok.png";

const TrainingPathTimeline: React.FC<{ items: TimelineItemModel[] }> = ({ items }) => {
  useEffect(() => {}, [items]);

  return (
    <>
      {items.length !== 0 && (
        <Chrono
          items={items}
          disableNavOnKey={true}
          mode="VERTICAL_ALTERNATING"
          hideControls={true}
          cardHeight={60}
          allowDynamicUpdate={true}
          theme={{
            primary: "#51925d",
            secondary: "#51925d",
            cardBgColor: "#fcfcfc",
            titleColor: "#fcfcfc",
          }}
        >
          <div className="chrono-icons">
            {items.map((item, index) => (
              <img key={index} src={item.active ? OkIcon : InProgressIcon} alt="" />
            ))}
          </div>
        </Chrono>
      )}
    </>
  );
};

export default TrainingPathTimeline;
